//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ResizeMixin from './mixin/ResizeHandler'
import AppMain from './components/AppMain'
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar/index'
import RightLayer from './components/RightLayer/index'
import { mapGetters } from 'vuex'
import { getRouter } from '@/utils/storage'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    RightLayer
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar () {
      return this.$store.state.app.sidebar
    },
    device () {
      return this.$store.state.app.device
    },
    classObj () {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    ...mapGetters([
      'menus',
      'menuId',
      'recodeMenu'
    ])
  },
  data () {
    return {
      levelList: [],
      icon: ''
    }
  },
  created () {
    this.getBreadcrumb(this.$route)
  },
  watch: {
    $route (to) {
      this.getBreadcrumb(to)
    }
  },
  methods: {
    handleClickOutside () {
      this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    },
    getBreadcrumb (to) {
      this.levelList = []
      let menuId
      let freshTime
      let localStorageMenuId = {}
      if (to) {
        menuId = to.query.resource
        freshTime = to.query.time
      }
      if (menuId && freshTime) {
        let href = ''
        for (let i = 0; i < this.recodeMenu.length; i++) {
          if (menuId == this.recodeMenu[i].menuId) {
            href = this.recodeMenu[i].href
            break
          }
        }
        if (href) {
          localStorageMenuId = {
            menuId: menuId,
            href: href
          }
        } else {
          localStorageMenuId = getRouter()
        }
      } else {
        localStorageMenuId = getRouter()
      }
      if ((this.menuId.menuId == -2 && localStorageMenuId.menuId == -2) ||
        to.fullPath === '/dashboard') {
        this.levelList.push('欢迎页')
        this.icon = 'dashboard'
        for (let i = 0; i < this.menus.length; i++) {
          if (this.menus[i].name === '欢迎页') {
            this.$store.dispatch('setMenuId', { href: this.menus[i].href, menuId: this.menus[i].menu_id })// 保存路由
            break
          }
        }
      } else {
        this.$store.dispatch('setMenuId', { href: localStorageMenuId.href, menuId: localStorageMenuId.menuId })// 保存路由
        this.getData(this.menus, localStorageMenuId.menuId)
      }
    },
    getData (data, id) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].menu_id == id) {
          this.levelList.unshift(data[i].name)
          if (data[i].parent_id != -1) {
            this.getData(this.menus, data[i].parent_id)
          }
          if (data[i].parent_id == -1) {
            this.icon = data[i].icon ? data[i].icon : 'dashboard'
          }
          return true
        } else {
          if (data[i].children && data[i].children.length > 0) {
            this.getData(data[i].children, id)
          }
        }
      }
    },
    handleRightLayer (component) {
      this.$refs.rightLayer.open(component)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/Layout.vue